import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import './index.css';
import './i18n';
import App from './App.tsx';
import { LoadingProvider } from './context/LoadingContext.tsx';
import { AlertProvider } from './hooks/useAlert.tsx';
import { ConfirmProvider } from './hooks/useConfirm.tsx';
import { stores } from './stores/stores.ts';
import { HelmetProvider } from 'react-helmet-async';
import { HashRouter } from 'react-router-dom';

createRoot(document.getElementById('root')!).render(
  <HelmetProvider>
    <Provider store={stores}>
      <AlertProvider>
        <ConfirmProvider>
          <LoadingProvider>
            <HashRouter>
              <App />
            </HashRouter>
          </LoadingProvider>
        </ConfirmProvider>
      </AlertProvider>
    </Provider>
  </HelmetProvider>
);
